import { createScrollbar } from '../common/scrollbar'

createScrollbar(document.querySelector('.section-about-company__text'))